// eslint-disable-next-line
const pt = {
  notFound_error404: "Oops! Tente novamente.",
  notFound_return: "Clique aqui para voltar à pagina inicial.",
  /* 
    SITE CEME KEYS
    IMPORTANT: 
      - IF A PARAGRAPH IS DESIRED, THE KEY VALUE MUST BE SEPARATED BY A ";". 
      - DON'T BEGIN OR END THE STRING WITH A ";" OR AN EXTRA <SPAN> WILL BE ADDED!
  */

  //DEFAULT.JS -
  //INTRO (FIRST TEXT)
  siteCeme_intro:
    "Comece a carregar imediatamente, sem aguardar por um cartão físico; Tarifário descomplicado; Encontre rapidamente os postos aos melhores preços; Acesso a milhares de postos em Portugal e na Europa; Possibilidade de integrar com carregamentos em espaços privados como em casa, no condomínio, ou na empresa",

  //ADVANTAGES (CARD TYPE)
  siteCeme_advantages_card1:
    "Acesso aos consumos via Web ou App (Android e IOS)",
  siteCeme_advantages_card2:
    "Cartão virtual para carregamento na rede MOBI.E através da App",
  siteCeme_advantages_card3:
    "Histórico e faturação (por empresa, veículo, condutor, cartão...)",
  siteCeme_advantages_card4: "Consumos agregados (via pública, trabalho, casa)",
  siteCeme_advantages_card5: "Estatísticas",
  siteCeme_advantages_card6: "Saiba mais",

  //CARDS.JS
  //CARD SECTION 1
  siteCeme_card1_bullet1_text_1:
    "Instale a App, registe-se, adicione um meio de pagamento e",
  siteCeme_card1_bullet1_text_2: " obtenha imediatamente o seu cartão virtual",
  siteCeme_card1_bullet1_text_3: ", sem ter de aguardar por um cartão físico.",
  siteCeme_card1_bullet1_title: "INSTALAR",
  siteCeme_card1_bullet2_text_1: "Encontre rapidamente os",
  siteCeme_card1_bullet2_text_2: " postos aos melhores preços",
  siteCeme_card1_bullet2_text_3:
    ", entre milhares de postos em Portugal e na Europa, incluindo na",
  siteCeme_card1_bullet2_text_4: " rede MOBI.E ",
  siteCeme_card1_bullet2_title: "PROCURAR POSTO ",
  siteCeme_card1_bullet3_text: "Comece imediatamente a carregar.",
  siteCeme_card1_bullet3_title: "CARREGAR",
  siteCeme_card1_bullet4_text:
    "Escolha a frequência de faturação: por sessão, semanal, quinzenal ou mensal.",
  siteCeme_card1_bullet4_title: "FATURAÇÃO",
  siteCeme_card1_bullet5_text_1: "A qualquer altura",
  siteCeme_card1_bullet5_text_2: " pode solicitar um cartão físico ",
  siteCeme_card1_bullet5_text_3:
    "através da App, na opção 'Pedir cartão físico', na secção “Cartões” do seu cartão virtual. Após receber o cartão físico, só tem de o ativar através da App e aguardar até 48h pela notificação de confirmação.",
  siteCeme_card1_bullet5_text:
    "A qualquer altura pode solicitar um cartão físico através da App, na opção 'Pedir cartão físico', na secção “Cartões” do seu cartão virtual. Após receber o cartão físico, só tem de o ativar através da App e aguardar até 48h pela notificação de confirmação.",
  siteCeme_card1_bullet5_title: "CARTÃO FÍSICO ",

  //CARD SECTION 2
  siteCeme_card2_main_text:
    'Para pedir um cartão físico terá de ser cliente EVIO e aderir a um contrato CEME (para mais informações avance para a secção "CARTÃO VIRTUAL"',
  siteCeme_card2_bullet1_text:
    'Na área de contratos da App, na secção MOBI.E, selecione a opção "Pedir cartão físico"',
  siteCeme_card2_bullet1_title: "ADERIR",
  siteCeme_card2_bullet2_text:
    "Após receber o cartão físico, proceda por favor à ativação do mesmo na App.",
  siteCeme_card2_bullet2_title: "RECEBER E ATIVAR",
  siteCeme_card2_bullet3_text:
    "No prazo de 48h irá receber uma notificação a confirmar a ativação do cartão físico para funcionamento na rede MOBI.E",
  siteCeme_card2_bullet3_title: "CONFIRMAÇÃO",
  siteCeme_card2_bullet4_text:
    "Passe o seu cartão físico em qualquer posto da rede MOBI.E para iniciar o carregamento.",
  siteCeme_card2_bullet4_title: "CARREGAR",
  siteCeme_card2_bullet5_text: "No final do mês receberá uma fatura detalhada.",
  siteCeme_card2_bullet5_title: "FATURA",

  //TARIFF.JS
  //CARD 1
  siteCeme_tariff_card1_bottom:
    "Aos preços apresentados acresce o valor da Tarifa de Acesso às Redes de mobilidade elétrica em vigor (de 0,0812€/kWh em MT Fora de Vazio, 0,0157€/kWh em MT Vazio, 0,1192€/kWh em BT Fora de Vazio e 0,0266€/kWh em BT Vazio), IVA, Imposto Especial de Consumo de 0,001€/kWh.",
  siteCeme_tariff_card1_bottom_1: "Aos preços apresentados",
  siteCeme_tariff_card1_bottom_2:
    "Períodos horários de Vazio e Fora de Vazio, do ciclo diário, opção bi-horária,",
  siteCeme_tariff_card1_bottom_3:
    " acresce o valor da Tarifa de Acesso às Redes de mobilidade elétrica em vigor (de 0,0812€/kWh em MT Fora de Vazio, 0,0157€/kWh em MT Vazio, 0,1192€/kWh em BT Fora de Vazio e 0,0266€/kWh em BT Vazio), IVA, Imposto Especial de Consumo de 0,001€/kWh.",
  siteCeme_tariff_card1_subtitle:
    "(tarifa CEME em vigor a partir de 01/08/2026)",
  siteCeme_tariff_card1_text:
    "Cartão físico e app móvel gratuitos;Pague sempre o mesmo valor pela energia;Sem custo de adesão, sem fidelização;Energia 100% verde, sem emissões de CO",
  siteCeme_tariff_card1_link: "Contacte-nos para descontos de grandes frotas",
  siteCeme_tariff_card1_title: "Preço da energia EVIO",

  //CARD 2
  siteCeme_tariff_card2_bottom:
    "O preço de cada posto de carregamento na rede pública é definido pelo respetivo operador e pode ser facilmente consultado na App EVIO",
  siteCeme_tariff_card2_subtitle: "(tarifa OPC)",
  siteCeme_tariff_card2_text: "Consulte o preço de todos os postos na App EVIO",
  siteCeme_tariff_card2_title: "Preço do posto ",

  //CARD 3
  siteCeme_tariff_card3_bottom:
    "IEC = 0,001 €/kWh ; IVA = 23% Continente, 18% Açores e 22% Madeira; EGME CEME = consultar detalhe; TAR = consultar detalhe; Apoio Público = 0,1902€ / sessão",
  siteCeme_tariff_card3_text:
    "Tarifa de Acesso às Redes (TAR); Imposto Especial sobre o Consumo (IEC); Tarifa Entidade Gestora da Rede de Mobilidade Elétrica (EGME) aplicável ao CEME; Imposto sobre o Valor Acrescentado (IVA); Apoio Público à Mobilidade Elétrica",
  siteCeme_tariff_card3_title: "TARIFAS, TAXAS E IMPOSTOS",

  //BOTTOM TEXT
  siteCeme_tariff_bottom_text:
    "Simule na App o preço total, antes do carregamento; Tarifário de energia descomplicado, com tudo incluído",
  siteCeme_tariff_bottom_title: "PREÇO SEM COMPLICAÇÕES",

  //JOIN.JS
  //ACTIVATION SECTION
  siteCeme_activation_text:
    'Se solicitou um cartão físico e não apenas um cartão virtual, e se já o recebeu, então tem de proceder à ativação do mesmo. Pode ativar o seu cartão físico EVIO através da APP na área de contratos, na secção MOBI.E, selecionando a opção "Ativar cartão" (será necessário o seu NIPC/NIF, email e o nº cartão). Após solicitar a ativação do cartão irá receber uma notificação a confirmar a ativação do mesmo para a rede MOBI.E.',
  siteCeme_activation_title: "Ative o seu Cartão Físico",
};
export default pt;
